import React, { useEffect, useState } from "react";
import "../App.css";
import ImageGallery from "../ImageGallery";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";

function LatestYouTubeVideo() {
  const [videoId, setVideoId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchLatestVideo() {
      try {
        const response = await fetch("/api/youtube/latest");
        const data = await response.json();
        if (data && data.videoId) {
          setVideoId(data.videoId);
        }
      } catch (e) {
        setVideoId(null);
      } finally {
        setLoading(false);
      }
    }
    fetchLatestVideo();
  }, []);

  if (loading) return <div className="youtube-container">加载中…</div>;
  if (!videoId) return <div className="youtube-container">未找到最新视频</div>;
  return (
    <div className="youtube-container">
      <iframe
        width="560"
        height="315"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        style={{ borderRadius: 16 }}
      ></iframe>
    </div>
  );
}

function HomePage() {
  return (
    <>
      <div className="main-content">
        <EditableText
          id="home.title"
          defaultContent="主页"
          defaultStyle={{ fontSize: "30px", textAlign: "left", marginTop: "4px", marginLeft: "20px", marginBottom: "0px", color: "#000000" }}
        />
      </div>
      <div style={{marginTop: "0px"}}>
        <ImageGallery folder="homepage_images" slotId="home.hero" />
      </div>
      <LatestYouTubeVideo />
      <div className="main-content">
        <EditableText
          id="home.intro"
          defaultContent="香槟-厄巴纳生命河教会是一家以传讲耶稣基督，教导上帝的话语和门徒建造为核心的教会。教会的名字取自启示录22章1-2节有关生命的异象："
          defaultStyle={{ marginTop: "40px", marginLeft: "80px" }}
        />
        <EditableText
          id="home.verse"
          defaultContent="“有一道生命河明亮如水晶，从神的宝座流出来，在河的这边和那边有生命树，结十二样的果子…”"
          defaultStyle={{ marginTop: "40px", marginLeft: "80px", color: "#54aaff", fontWeight: 500 }}
        />
        <EditableText
          id="home.vision"
          defaultContent="生命河教会的负担是服事这一代的年轻人和城市福音的需要。教会的异象是：建造下一代的门徒, 扩展上帝的国度; 教会的使命是: 传福音建造主的门徒. 生命河教会注重真理的教导，关心人灵魂的得救，弟兄姐妹属灵生命的成长，和门徒及同工的建造。欢迎您和我们同工，一起建造神的教会，顺服主的大使命，见证和荣耀神的名。"
          defaultStyle={{ marginTop: "40px", marginLeft: "80px" }}
        />
        <EditableText
          id="home.address"
          defaultContent={"地址：[600 E Pennsylvania Avenue, Urbana, IL 61801\nPennsylvania Avenue Baptist Church (PABC)](https://www.google.com/maps/place/600+E+Pennsylvania+Ave,+Urbana,+IL+61801)\n公交路线：[5/50 Green East (从 Illini Union 出发10分钟可达)](https://mtd.org/maps-and-schedules/routes|#327818)"}
          defaultStyle={{ textAlign: "center", marginTop: "32px", marginBottom: "16px", color: "#000000" }}
        />
        <br />
        <br />
        <EditableText
          id="home.schedule-title"
          as="h2"
          defaultContent="教会每周活动日程"
          defaultStyle={{ textAlign: "center", color: "#000000", marginTop: "32px", marginBottom: "16px" }}
        />
        <EditableText
          id="home.schedule"
          as="div"
          defaultContent={"周二祷告会　7:30 AM – 8:30 AM\n周五团契　晚餐 中文圣经学习　6:30 PM – 9:00 PM\n周六 免费中文课程　10:00AM – 12:00PM\n周日敬拜　9:30 AM – 10:30 AM（主日学）\n　　　　　　10:45 AM – 12:15 PM（主日敬拜）"}
          defaultStyle={{ textAlign: "center", marginBottom: "16px" }}
        />
        <br />
        <div style={{
  width: '70%',
  height: '1px',
  background: '#ccc',
  margin: '20px auto'
}} />
      
        <EditableText
          id="home.friday-title"
          as="h2"
          defaultContent="邀请您参加我们周五的圣经学习"
          defaultStyle={{ textAlign: "center", color: "#000000", marginTop: "32px", marginBottom: "16px" }}
        />
        <ImageGallery folder="homepage_friday_images" slotId="home.friday" variant="strip" />

        <div style={{textAlign: 'center',marginBottom: 16}}>
          <br />
          <br />
          <br />
          <EditableText
            id="home.welcome"
            defaultContent="欢迎您前来教会参加主日学，主日敬拜（二楼）和周五晚上的团契。"
          />
          <EditableText
            id="home.zoom"
            defaultContent={"除了实体的主日敬拜，我们也提供线上参与联络。主日敬拜 Zoom 链接：\n[https://zoom.us/j/8866071832?pwd=U2l0a2E5YzhDeGUxUGc5NSswai9sdz09](https://zoom.us/j/8866071832?pwd=U2l0a2E5YzhDeGUxUGc5NSswai9sdz09)"}
            defaultStyle={{ textAlign: "center" }}
          />
          <EditableText
            id="home.youtube"
            defaultContent={"欢迎到上面讲道信息相关网页或者YouTube频道观看我们的主日讲道：\n[https://www.youtube.com/channel/UCsB7atMvcso2DDr2xe8v_fw](https://www.youtube.com/channel/UCsB7atMvcso2DDr2xe8v_fw)"}
            defaultStyle={{ textAlign: "center" }}
          />
          <EditableText
            id="home.facebook"
            defaultContent={"欢迎您浏览教会Facebook网页：\n[https://www.facebook.com/RiverofLife.CCU](https://www.facebook.com/RiverofLife.CCU)"}
            defaultStyle={{ textAlign: "center" }}
          />
          <PageCopyright pageId="home" />
        </div>
      </div>
    </>
  );
}

export default HomePage;
